<template>
    <div style="background-color: #d3d3d321;">
    <v-container>
  <div class="offices">
    <div v-for="office in offices" :key="office.country" class="office">
      <!-- Image -->
      <img :src="office.image" alt="" class="office-img" />

      <!-- Icon -->
      <div class="icon-box">
        <svg xmlns="http://www.w3.org/2000/svg" style="width: 30px;
    height: 30px;filter: invert(1)" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
<g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
	<path d="M 81.353 50.79 L 63.143 36.799 l 18.302 -15.87 c 0.834 -0.723 0.924 -1.986 0.2 -2.82 c -0.723 -0.834 -1.985 -0.925 -2.82 -0.201 L 58.682 35.374 c -0.005 0.004 -0.009 0.008 -0.014 0.012 l -4.921 4.267 L 28.669 17.907 c -0.834 -0.724 -2.096 -0.633 -2.82 0.201 c -0.723 0.834 -0.634 2.097 0.201 2.82 l 18.44 15.99 l -12.442 9.912 c -0.864 0.688 -1.006 1.946 -0.318 2.81 c 0.395 0.496 0.977 0.754 1.565 0.754 c 0.436 0 0.876 -0.143 1.244 -0.435 l 13.024 -10.375 l 4.874 4.226 c 0.376 0.326 0.843 0.489 1.31 0.489 c 0.467 0 0.934 -0.163 1.31 -0.489 l 5.002 -4.337 l 18.858 14.488 c 0.363 0.279 0.792 0.414 1.217 0.414 c 0.599 0 1.193 -0.268 1.586 -0.781 C 82.393 52.718 82.229 51.463 81.353 50.79 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
	<path d="M 84.004 10.598 H 23.49 c -3.306 0 -5.996 2.69 -5.996 5.996 v 1.616 c -1.125 -0.827 -2.636 -1.044 -3.982 -0.453 c -0.87 0.383 -2.006 0.88 -3.19 1.394 l -0.032 0.014 c -2.526 1.095 -4.385 1.88 -5.378 2.269 c -0.741 0.29 -1.362 0.72 -1.845 1.278 c -8.173 9.429 1.178 26.658 14.071 39.551 c 9.539 9.539 21.449 17.14 30.82 17.139 c 3.296 -0.001 6.278 -0.941 8.731 -3.066 c 0.557 -0.483 0.987 -1.104 1.278 -1.846 c 0.395 -1.009 1.171 -2.847 2.304 -5.456 c 0.507 -1.168 0.996 -2.286 1.373 -3.144 c 0.621 -1.413 0.355 -3.01 -0.578 -4.148 h 22.939 c 3.307 0 5.996 -2.69 5.996 -5.996 v -39.15 C 90 13.288 87.31 10.598 84.004 10.598 z M 56.603 67.439 c -1.152 2.656 -1.947 4.538 -2.36 5.592 c -0.05 0.127 -0.113 0.23 -0.173 0.282 c -7.118 6.171 -22.543 -2.315 -34.105 -13.877 C 8.402 47.872 -0.078 32.445 6.088 25.331 c 0.053 -0.061 0.156 -0.124 0.283 -0.174 c 1.063 -0.416 2.944 -1.21 5.592 -2.359 v 0 c 1.173 -0.509 2.296 -1 3.168 -1.373 l 7.266 12.256 l -4.505 8.393 c -0.843 1.57 -0.562 3.471 0.698 4.732 l 14.007 14.007 c 1.262 1.26 3.164 1.541 4.731 0.696 l 8.404 -4.505 l 12.245 7.267 l 0.006 0.01 C 57.603 65.144 57.11 66.268 56.603 67.439 z M 86.001 55.744 c 0 1.101 -0.896 1.997 -1.997 1.997 H 54.809 l -7.038 -4.177 c -1.201 -0.712 -2.711 -0.744 -3.942 -0.083 l -8.406 4.503 l -14.008 -14.02 l 4.505 -8.392 c 0.66 -1.231 0.628 -2.741 -0.084 -3.943 l -4.343 -7.319 v -7.716 c 0 -1.101 0.896 -1.997 1.997 -1.997 h 60.514 c 1.101 0 1.997 0.896 1.997 1.997 V 55.744 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
</g>
</svg>
      </div>

      <!-- Text -->
       <div> <h3>{{ office.country }}</h3></div>
     
      <div>{{ office.phone }}</div>
      <div>
        <a :href="'mailto:' + office.email">{{ office.email }}</a>
      </div>
      
    </div>
  </div>

  <div class="mt-3">
    <h5 style="font-size: 17px;
    font-weight: 600;color:#E11C09
">Contact Us</h5>
    <h1 style="font-size: 30px;
    font-weight: 900;">
        Drop Us a Line !
    </h1>
<v-form class="mt-3" ref="form" v-model="formValid" @submit.prevent="submitForm">
    <div class="row">
      <div class="col-md-4">
        <v-text-field
        class="contact-form"
          label=" Name"
          variant="outlined"
          v-model="contactDetails.name"
          :rules="[(v) => !!v || 'This field is required']"
        ></v-text-field>
      </div>

      <div class="col-md-4">
        <v-text-field
         class="contact-form"
          label=" Email"
          variant="outlined"
          v-model="contactDetails.email"
          :rules="[
            (v) => !!v || 'This field is required',
            (v) => /.+@.+\..+/.test(v) || 'Please enter a valid email address'
          ]"
        ></v-text-field>

      </div>
<div class="col-md-4">
       <v-text-field
  label="Phone Number"
   class="contact-form"
  variant="outlined"
   minlength="5"
  maxlength="15"
  type="number"
  v-model="contactDetails.phone"
  :rules="[
        (v) => !!v || 'Phone Number is required',
        (v) => /^\+?\d{5,15}$/.test(v) ||'Invalid Phone Number'
      ]"
></v-text-field>

      </div>

    </div>
 <div class="row mt-2">
      <div class="col-md-4">
        

        <VAutocomplete
                    v-model="selectedFromcountry"
                    :items="filteredCountryNames"
                    variant="outlined"
          label="Country"
                    required
                    placeholder=" Country"
                    :rules="overallFormValidation"
                    class="d-flex flex-column contact-form"
                  />
      </div>

      <div class="col-md-4">
        <!-- <v-text-field
          label="Move From"
           class="contact-form"
          variant="outlined"
          v-model="contactDetails.city"
          :rules="[
            (v) => !!v || 'This field is required'
          ]"
        ></v-text-field> -->

        <div class=" postal-country">
                <div>
                  <!-- <label class="v-label">POSTALCODE/LOCATION</label> -->
                  <v-text-field
                    v-model="fromPostalcode"
                    variant="outlined"
                    label="Location/PostalCode"
                    :rules="overallFormValidation"
                    required
                    @click="fromPostalUl = true,
                    this.fromPostalcode = null
                    "
                  >
                    <template>
                      <VProgressCircular
                        color="primary"
                        v-if="aerch1"
                        indeterminate
                      />
                    </template>
                  </v-text-field>
                </div>

                <ul
                  v-if="fromPostalcodeList.length > 0 && fromPostalUl"
                  class="dropdowdata"
                >
                  <li
                    v-for="postalCode in fromPostalcodeList"
                    :key="postalCode"
                    @click="
                      selectedFromPostal(
                        postalCode.zipcode,
                        postalCode.cityname
                      )
                    "
                    style="font-size: 13px; font-weight: 500;margin: 3px;"
                  >
                    {{ postalCode.zipcode }}-{{ postalCode.cityname }}
                  </li>
                </ul>

              </div>

      </div>
<div class="col-md-4">
  
 <v-select
                          v-model="contactDetails.type"
                          variant="outlined"
                           
                          class="contact-form"
                          :items="[
                            'General Enquiry',
'Booking Status',
'Report Issues',
'Complaints',
                          ]"
                        />

      </div>

    </div>
    <div class="d-flex flex-wrap justify-content-between">
        <div  class="w-50">
            <v-textarea
  label="Message"
  variant="outlined"
  v-model="contactDetails.msg"
  
></v-textarea>

        </div>
        <div>
             <v-btn type="submit" color="#E11C09" class="mt-4">Send message</v-btn>
        </div>
    </div>
   
  </v-form>
   
  </div>
  </v-container>
  </div>
</template>

<script >
import countryList from "@/countries.json";
import axios from "axios";
export default{
    data(){
        return{
              countryListarray: [],
              fromcountryCode: [],
              selectedFromcountry:null,
                 fromPostalcodeList: [],
                 fromPostalcode:"",
       contactForm:false,
       contactDetails:{
name:"",
email:"",
phoneNumber:"",
city:null,
country:null,
type:"General Enquiry",
msg:""

       },
       overallFormValidation: [(v) => !!v || "Please enter a valid input"],

             offices :[
  {
    country: "Australia",
    phone: "+61 452 201 075",
    email: "sales@majesticcourier.com",
    icon: "fas fa-map-marker-alt",
    image: "https://www.svgrepo.com/show/405417/flag-for-flag-australia.svg",
  },
  {
    country: "Canada",
    phone: "+1 416 439 4020",
    email: "canada@majesticcourier.com",
    icon: "fas fa-phone",
    image: "https://www.svgrepo.com/show/248844/canada.svg",
  },
  {
    country: "India",
    phone: "+91 81 2424 3000",
    email: "india@majesticcourier.com",
    icon: "fas fa-phone",
    image: "	https://www.svgrepo.com/show/405510/flag-for-flag-india.svg",
  },
  {
    country: "Switzerland",
    phone: "+41 44 315 5840",
    email: "swiz@majesticcourier.com",
    icon: "fas fa-envelope",
    image: "https://www.svgrepo.com/show/405625/flag-for-flag-switzerland.svg",
  }
]
        }
    },

    computed: {
    filteredCountryNames() {
      console.log(countryList,'countryList')
      countryList.forEach((item) => {
        return this.countryListarray.push({
          code: item.code,
          country: item.name,
        });
      });

      return countryList.map((country) => country.name);
    }
},
    methods: {
        selectedFromPostal(data1, data2) {
      if (data1 == null) {
        data1 = "";
        this.fromPostalcode = `${data1}-${data2}`;
      } else {
        this.fromPostalcode = `${data1} - ${data2}`;
      }
      this.fromPostalUl = false;
      this.postalsplittedFrom = this.fromPostalcode.split("-");
      console.log(this.postalsplittedFrom, " this.postalsplittedFrom");
      this.fromCity =
        this.postalsplittedFrom[this.postalsplittedFrom.length - 1];
      this.countryPostalcontFrom = true;
    },
    submitForm() {
      if (this.$refs.form.validate()) {
        console.log("Form submitted:", this.contactDetails);
      } else {
        console.log("Form has errors");
      }
    },

    
  },
  watch:{
     selectedFromcountry(newval) {
      console.log(newval, "newval");
      this.aerch1 = true;
      this.fromcountryCode = [];
      this.fromPostalcodeList = [];
      this.fromPostalcode = null;
      this.countryListarray.filter((item) => {
        console.log(item, "itemitem2222222 ");
        if (item.country === newval) {
          this.fromcountryCode.push(item);
        }
      });
    },
     async fromPostalcode(val) {
        // console.log(val,this.fromcountryCode,'ppppppppp')
      this.fromPostalcodeList=[]
      if (val) {
        let PostalData = {
          enteredvalue: val,
          countrycode: this.fromcountryCode[0].code,
        };
        console.log(PostalData, "PostalData");
        if (val.length >= 3) {
          await axios
            .post(
              `https://connect.Majesticcourier.com/api/postalapi`,
              PostalData,
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              console.log(response, "responseresponse");
              let data = response.data;

    if (data && Array.isArray(data.data)) {
      data = data.data;
    }

    if (Array.isArray(data) && data.length > 0) {
      this.fromPostalcodeList = data.map((items) => ({
        cityname: items.name,
        zipcode: items.zip_code,
      }))}
              // this.fromPostalcodeList = response?.data?.map((item) => ({
              //   cityname: item.name,
              //   zipcode: item.zip_code,
              // }));
            });
          console.log(
            this.fromPostalcodeList,
            this.fromPostalUl,
            "frompostallist"
          );
        }
      }
    },
  }
}
</script>

<style scoped>
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css");
 :deep(.contact-form .v-input__control) {
    display: flex;
    grid-area: control;
    height: 45px;
}
:deep(.contact-form .v-field--center-affix .v-label.v-field-label) {
    top: 40%;
    transform: translateY(-50%);
}
>>>.v-text-field input:focus{
    border:none !important;
    background: none !important;
}

 :deep(.postal-country .v-input__control) {
    display: flex;
    grid-area: control;
    height: 45px;
}
:deep(.postal-country .v-field--center-affix .v-label.v-field-label) {
    top:27%;
    transform: translateY(-50%);
}

.offices {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}
.office {
  text-align: center;
  padding: 15px;
  border-radius: 10px;
}
.office-img {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
}
.icon-box {
  margin-top: -20px;
  background: red;
  color: white;
  display: inline-block;
  padding: 10px;
 border: 5px solid white;
    width: 65px;
}
.icon-box i {
  font-size: 20px;
}
h3 {
  margin-top: 10px;
  font-weight: bold;
}
:deep(.postal-country .v-text-field input) {
    position: relative;
    top: -13px;
}

    .dropdowdata {
  position: absolute;
  z-index: 99;
  padding: 5;
  border-radius: 8px;
  margin: 0;
  background-color: white;
  box-shadow: inset 0 0 2px black;
  max-width: 100%;
  list-style: none;
  margin-block-start: 7px;
  overflow-y: scroll;
  height:250px;
      width: 250px;
  cursor: pointer;
}

.dropdowdatali {
  padding: 10px;
  cursor: pointer;
}

.dropdowdatali:hover {
  background-color: #f0f0f0;
}
>>>.v-autocomplete--single:not(.v-autocomplete--selection-slot) .v-field--active input {
    transition: none;
    top: 0px;
}

</style>
